import { IModalWindow } from '@hooks/useModalWindow';
import { IComboEmpresa } from '@model/Empresa';
import { IVendedor } from '@model/Vendedor';
import { IVendedorComissao, VendedorComissaoTipoEnum } from '@model/VendedorComissao';
import React from 'react';
import { ComissaoRegistrarModal } from './ComissaoRegistrarModal';

export type ComissaoPagamentoModalProps = {
    modal: IModalWindow
    onComissaoRegistrada: (vendedorComissao: IVendedorComissao) => void
    vendedor: IVendedor
    comboEmpresa: IComboEmpresa
}

export function ComissaoPagamentoModal ({ modal, vendedor, onComissaoRegistrada, comboEmpresa }: ComissaoPagamentoModalProps) {
    return (
        <ComissaoRegistrarModal 
            modal={modal}
            vendedorComissaoTipo={VendedorComissaoTipoEnum.Pagamento}
            onComissaoRegistrada={onComissaoRegistrada}
            vendedor={vendedor}
            comboEmpresa={comboEmpresa}
        />
    )
}